import React from 'react'
import { RenderIcon } from 'src/assets/icons'
import { Button } from './ui/Button'

interface NoDataFoundProps {
  action?: boolean;
  handleAction?: () => void;
  compact?: boolean;
}

const NoDataFound: React.FC<NoDataFoundProps> = ({ action = false, handleAction, compact = false }) => {
  return (
    <div className={`w-[100%] ${compact ? 'h-full' : 'h-[65vh]'} flex flex-col justify-center items-center gap-[8px]`}>
      <RenderIcon type='emojiSadIcon' width={36} height={36} />
      <div className='font-popins font-normal text-[16px] leading-[22.4px] text-[#FFFFFF]'>No Data Available</div>
      <div className='font-popins font-normal text-[14px] leading-[19.88px] text-[#A1A1A1] w-[243px] sm:w-[100%] text-center'>Try selecting a different time range to see data.</div>
      {action && (
        <Button variant='primary' onClick={handleAction} className='w-[100%] sm:w-[348px] mt-[19px]'>
          Update Time Range
        </Button>
      )}
    </div>
  )
}

export default NoDataFound
